// extracted by mini-css-extract-plugin
export default {"root":"tPqgfyW","heading":"_8BBNMDE","container":"rB9_FrC","pillContainer":"oCez64v","uncategorizedTitle":"FRNOGP2"};